//域名
const domain = window.location.host + "/api";
// const domain = "localhost:9972/";
// const domain = window.location.host;

//端口
const port = null;

const path = "";

//路径
const root =
  window.location.protocol + "//" + domain + (port ? ":" + port : "") + path;


//接口
const api = {
  demo: {
    list: `${root}/user/list`,
    add: `${root}/user/add`,
    update: `${root}/user/update`,
    detail: `${root}/user/detail`,
    delete: `${root}/user/delete`,
    batchDelete: `${root}/user/batchDelete`
  },
  common: {
    loadBrandOwnerProduct: `${root}/common/loadBrandOwnerProduct`,
    loadCountry: `${root}/common/loadCountry`,
    loadDict: `${root}/common/loadDict`,
    dict: `${root}/dictType/list`,
    loadSysSupportLang: `${root}/common/loadSysSupportLang`,
    loadProduct: `${root}/common/loadProduct`,
    loadSubBrand: `${root}/common/loadSubBrand`,
    downloadImportAccountTpl: `${root}/common/downloadImportAccountTpl`,
    loadArea: `${root}/common/loadArea`,
    loadBrandProductTree: `${root}/common/loadBrandProductTree`,
    loadSubBrandProduct: `${root}/common/loadSubBrandProduct`,
    accessory: `${root}/accessory/listAll`,
    loadTagsByLang: `${root}/common/loadTagsByLang`,
    loadRecipeCategoryRanking: `${root}/common/loadRecipeCategoryRanking`,
    loadBrandRecipeRanking: `${root}/common/loadBrandRecipeRanking`,
    loadBrandIndexCount: `${root}/common/loadBrandIndexCount`
  },
  sysSupportLang: {
    list: `${root}/sysSupportLang/list`,
    update: `${root}/sysSupportLang/save`
  },

  file: {
    upload: `${root}/file/upload`,
    download: `${root}/file/download`,
    downloadImg: `${root}/file/download?fileCode=`
  },

  login: {
    captcha: `${root}/auth/captcha`,
    login: `${root}/auth/login`
  },

  subApk: {
    list: `${root}/subApk/list`,
    add: `${root}/subApk/add`,
    update: `${root}/subApk/update`,
    detail: `${root}/subApk/detail`,
    delete: `${root}/subApk/delete`,
    batchDelete: `${root}/subApk/batchDelete`,
    addAndApproval: `${root}/subApk/addAndApproval`,
    commitApproval: `${root}/subApk/commitApproval`,
    recall: `${root}/subApk/recall`,
    updateTestStatus: `${root}/subApk/updateTestStatus`,
    updateReleaseStatus: `${root}/subApk/updateReleaseStatus`,
    lastSubmitVersionInfo: `${root}/subApk/lastSubmitVersionInfo`,
  },

  email: {
    captcha: `${root}/emailRecord/captcha`,
    verify: `${root}/emailRecord/verify`,
    setPassword: `${root}/sysUser/setPassword`,
    updatePassword: `${root}/sysUser/updatePassword`
  },

  deviceFaultLog: {
    summary: `${root}/deviceFaultLog/summary`,
    list: `${root}/deviceFaultLog/list`,
    delete: `${root}/deviceFaultLog/delete`,
    batchDelete: `${root}/deviceFaultLog/batchDelete`
  },

  accessory: {
    list: `${root}/accessory/list`,
    add: `${root}/accessory/add`,
    update: `${root}/accessory/update`,
    detail: `${root}/accessory/detail`,
    delete: `${root}/accessory/delete`,
    batchDelete: `${root}/accessory/batchDelete`
  },

  device: {
    list: `${root}/device/list`,
    add: `${root}/device/add`,
    update: `${root}/device/update`,
    detail: `${root}/device/detail`,
    delete: `${root}/device/delete`,
    batchDelete: `${root}/device/batchDelete`
  },

  testDevice: {
    list: `${root}/testDevice/list`,
    add: `${root}/testDevice/add`,
    update: `${root}/testDevice/update`,
    detail: `${root}/device/detail`,
    delete: `${root}/testDevice/delete`,
    batchDelete: `${root}/testDevice/batchDelete`,
    search: `${root}/testDevice/search`
  },

  user: {
    list: `${root}/user/list`,
    add: `${root}/user/add`,
    update: `${root}/user/update`,
    detail: `${root}/user/detail`,
    delete: `${root}/user/delete`,
    batchDelete: `${root}/user/batchDelete`,
    search: `${root}/user/search`
  },

  lockScreenAds: {
    list: `${root}/lockScreenAds/list`,
    add: `${root}/lockScreenAds/add`,
    update: `${root}/lockScreenAds/update`,
    detail: `${root}/lockScreenAds/detail`,
    delete: `${root}/lockScreenAds/delete`,
    batchDelete: `${root}/lockScreenAds/batchDelete`,
    search: `${root}/lockScreenAds/search`
  },

  vipUser: {
    list: `${root}/vipUser/list`,
    importData: `${root}/vipUser/importData`,
    detail: `${root}/vipUser/detail`,
    delete: `${root}/vipUser/delete`,
    batchDelete: `${root}/vipUser/batchDelete`
  },

  userSearchRecord: {
    list: `${root}/userSearchRecord/list`,
    add: `${root}/userSearchRecord/add`,
    update: `${root}/userSearchRecord/update`,
    detail: `${root}/userSearchRecord/detail`,
    delete: `${root}/userSearchRecord/delete`,
    batchDelete: `${root}/userSearchRecord/batchDelete`,
    search: `${root}/userSearchRecord/search`,
    exportData: `${root}/userSearchRecord/exportData`,
  },

  inform: {
    list: `${root}/inform/list`,
    add: `${root}/inform/add`,
    update: `${root}/inform/update`,
    detail: `${root}/inform/detail`,
    delete: `${root}/inform/delete`,
    batchDelete: `${root}/inform/batchDelete`,
    search: `${root}/inform/search`,
    addAndPush: `${root}/inform/addAndPush`,
    push: `${root}/inform/push`
  },

  hotTag: {
    list: `${root}/hotTag/list`,
    add: `${root}/hotTag/add`,
    update: `${root}/hotTag/update`,
    detail: `${root}/hotTag/detail`,
    delete: `${root}/hotTag/delete`,
    batchDelete: `${root}/hotTag/batchDelete`,
    search: `${root}/hotTag/search`
  },
  // 食谱标签
  recipeTag: {
    list: `${root}/recipeTag/list`,
    add: `${root}/recipeTag/add`,
    update: `${root}/recipeTag/update`,
    detail: `${root}/recipeTag/detail`,
    delete: `${root}/recipeTag/delete`,
    batchDelete: `${root}/recipeTag/batchDelete`,
    search: `${root}/recipeTag/search`,
  },

  // 食谱分类
  recipeCategory: {
    list: `${root}/recipeCategory/list`,
    add: `${root}/recipeCategory/add`,
    update: `${root}/recipeCategory/update`,
    detail: `${root}/recipeCategory/detail`,
    delete: `${root}/recipeCategory/delete`,
    batchDelete: `${root}/recipeCategory/batchDelete`,
    search: `${root}/recipeCategory/search`
  },

  recipeUserEvaluation: {
    list: `${root}/recipeUserEvaluation/list`,
    add: `${root}/recipeUserEvaluation/add`,
    update: `${root}/recipeUserEvaluation/update`,
    detail: `${root}/recipeUserEvaluation/detail`,
    delete: `${root}/recipeUserEvaluation/delete`,
    batchDelete: `${root}/recipeUserEvaluation/batchDelete`,
    search: `${root}/recipeUserEvaluation/search`
  },

  offlineRecipes: {
    list: `${root}/offlineRecipes/list`,
    add: `${root}/offlineRecipes/add`,
    update: `${root}/offlineRecipes/update`,
    detail: `${root}/offlineRecipes/detail`,
    delete: `${root}/offlineRecipes/delete`,
    batchDelete: `${root}/offlineRecipes/batchDelete`,
    search: `${root}/offlineRecipes/search`,
    updateReleaseStatus: `${root}/offlineRecipes/updateReleaseStatus`,
    updateTestStatus: `${root}/offlineRecipes/updateTestStatus`
  },

  recipe: {
    add: `${root}/recipe/add`,
    list: `${root}/recipe/list`,
    export: `${root}/recipeUtils/export`,
    asyncTaskDetail: `${root}/asyncTask/detail`,
    importData: `${root}/recipeUtils/importData`,
    detail: `${root}/recipe/detail`,
    simulatDetail: `${root}/simulat/recipeDetail`,
    update: `${root}/recipe/update`,
    delete: `${root}/recipe/delete`,
    submit: `${root}/recipe/submit`,
    copy: `${root}/recipe/copy`,
    save: `${root}/recipe/save`,
    batchRelease: `${root}/recipe/batchRelease`,
    batchSubmit: `${root}/recipe/batchSubmit`,
    batchDelete: `${root}/recipe/batchDelete`,
    batchUpdateBuyStatus: `${root}/recipe/batchUpdateBuyStatus`,
    batchUpdateOnlineStatus: `${root}/recipe/batchUpdateOnlineStatus`,
    countRemove: `${root}/recipe/countRemove`,
    batchRecallEditing: `${root}/recipe/batchRecallEditing`,
    batchRecallWaitRelease: `${root}/recipe/batchRecallWaitRelease`,
    recovery: `${root}/recipe/recovery`,
    clear: `${root}/recipe/clear`,
    batchClear: `${root}/recipe/batchClear`,
    batchRelModel: `${root}/recipe/batchRelModel`,
    batchDeleteModel: `${root}/recipe/batchDeleteModel`,
    batchUpdateCategory: `${root}/recipe/batchUpdateCategory`
  },
  boUnit: {
    add: `${root}/boUnit/add`,
    detail: `${root}/boUnit/detail`,
    update: `${root}/boUnit/update`,
    delete: `${root}/boUnit/delete`,
    list: `${root}/boUnit/list`,
  },
  cofarSdk: {
    allDevModes: `${root}/cofarSdk/allDevModes`
  },

  banner: {
    list: `${root}/ccBanner/list`,
    delete: `${root}/ccBanner/delete`,
    batchDelete: `${root}/ccBanner/batchDelete`,
    add: `${root}/ccBanner/add`,
    update: `${root}/ccBanner/update`,
    detail: `${root}/ccBanner/detail`,
  },

  specRecipe: {
    list: `${root}/specRecipe/list`,
    delete: `${root}/specRecipe/delete`,
    batchDelete: `${root}/specRecipe/batchDelete`,
    add: `${root}/specRecipe/add`,
    update: `${root}/specRecipe/update`,
    detail: `${root}/specRecipe/detail`,
    updateRefRecipe: `${root}/specRecipe/updateRefRecipe`,
    deleteRefRecipe: `${root}/specRecipe/deleteRefRecipe`,
  },

  appOnlineCategory: {
    add: `${root}/appOnlineCategory/batchAdd`,
    list: `${root}/appOnlineCategory/list`,
    batchDelete: `${root}/appOnlineCategory/batchDelete`,
    batchAddRecipe: `${root}/appOnlineCatRecipe/batchAdd`,
    batchDeleteByRecipe: `${root}/appOnlineCatRecipe/batchDelete`,
  },

  translate: `${root}/youdao/translate`,

  recipeCollect: {
    list: `${root}/recipeCollect/list`,
  },
};

export default Object.assign(
  {
    $base: {
      domain: domain,
      port: port,
      root: root
    }
  },
  api
);
